export const formatCurrency = (amount: number | undefined | null) => {
    if (amount === undefined || amount === null) return '-';
    return new Intl.NumberFormat('fr-HT', {
        style: 'currency',
        currency: 'HTG',
        minimumFractionDigits: 0,
    }).format(amount);
};
